import Link from 'next/link';
import { useRouter } from 'next/router';

import { Button } from 'themes/playful/components/Button/Button';
import { Item } from 'themes/playful/components/Item/PlayfulItem';
import { TextureSection } from 'themes/playful/components/TextureSection/TextureSection';

import { useBnplPromo } from 'hooks/bnpl/useBnplPromo';

import { BuyNowPayLaterPromo } from 'routes/invoices/components/BuyNowPayLaterPromo/BuyNowPayLaterPromo';
import { PackageItem } from 'routes/packages/types';

import { getBnplUnitPriceFromStringDollars } from 'utils/bnplUtils';

import s from './PlayfulPackages.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

type PlayfulPackagesProps = {
  packageList: PackageItem[];
};

export const PlayfulPackages = ({ packageList }: PlayfulPackagesProps) => {
  const { push } = useRouter();
  const { isEnabled, bnplCapabilities } = useBnplPromo();

  const onClick = () => {
    void push('/contact');
  };

  return (
    <TextureSection title="Packages">
      <div className={s1.content}>
        <p className={s.description}>
          <b>Already have a package?</b> Book as usual on our{' '}
          <Link href="/services">Services page</Link> — your credits will apply
          automatically at checkout.
          <br /> Coming soon, you&apos;ll be able to purchase your packages
          directly from this website.
        </p>
        <ul className={s.packageList}>
          {packageList?.map((packageItem) => {
            const bnplUnitPrice = isEnabled
              ? getBnplUnitPriceFromStringDollars(packageItem.price)
              : undefined;

            return (
              <li key={packageItem.token}>
                <Item
                  title={packageItem.name}
                  listView
                  button={
                    <Button className={s.button} onClick={onClick}>
                      Contact to purchase
                    </Button>
                  }
                >
                  <p>{packageItem.description}</p>
                  <div className={s.priceContainer}>
                    <p className={s.price}>
                      {packageItem.price} {bnplUnitPrice ? 'or' : null}
                    </p>
                    {bnplUnitPrice ? (
                      <BuyNowPayLaterPromo
                        unitAmount={bnplUnitPrice}
                        textAlign="left"
                        paymentMethodTypes={bnplCapabilities}
                      />
                    ) : null}
                  </div>
                  <ul className={s.items}>
                    {packageItem.items.map((item) => (
                      <li key={item.token}>
                        {item.quantity}x {item.name}
                      </li>
                    ))}
                  </ul>
                </Item>
              </li>
            );
          })}
        </ul>
      </div>
    </TextureSection>
  );
};
